export default "__VITE_ASSET__CBZai3$d__"